<template>
  <div class="home-page">
    <!-- 装修上化化，您的放心之选 -->
    <section class="hero" style="position: relative;">
      <div class="hero-content">
        <div class="hero-title">装修上化化</div>
        <h2 class="hero-title">您的放心之选</h2>
        <p class="hero-subtitle">找设计、找师傅、找装企，服务至满意为止。</p>
        <a class="hero-cta" href="#img-8" aria-label="立即体验">
          <img src="https://obs.huahuaeco.com/official/home/tryItNow.png" alt="立即体验" width="300" height="60" />
        </a>
      </div>
      <AppFooter v-show="showFooter" />
    </section>

    <!-- 开工0预付，装修更主动 -->
    <section id="img-1" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg.png')">
      <div class="img1-content">
        <h2 class="img1-title">开工0预付，装修更主动</h2>
        <p class="img1-desc">100%装修款由平台托管，按阶段验收、满意再付款。</p>
        <p class="img1-desc">用资金保障您的绝对话语权，让装修全程安心无忧。</p>
      </div>
      <img class="img1" src="https://obs.huahuaeco.com/official/home1.png" alt="">
    </section>

    <!-- 口碑全公开，好坏不隐藏 -->
    <section id="img-2" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')">
      <div class="img2-content">
        <h2 class="img2-title">口碑全公开，好坏不隐藏</h2>
        <div class="img2-desc">
          <p>每一位服务方的历史项目评价、优缺点均完整展示。</p>
          <p>为您提供最真实的“避坑指南”与决策参考，选择从未如此清晰。</p>
        </div>
      </div>
      <img class="img2" src="https://obs.huahuaeco.com/official/home2.png" alt="">
    </section>

    <!-- 告别装修扯皮，把“省心”装回家 -->
    <section id="img-3" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg.png')">
      <div class="img3-content">
        <h2 class="img3-title">告别装修扯皮，把“省心”装回家</h2>
        <p class="img3-desc">交易在线、过程透明、信息可查。</p>
        <p class="img3-desc">平台作为您最可靠的后盾。</p>
        <p class="img3-desc">让纠纷处理变得轻松简单，装修全程省心又省力。</p>
      </div>
      <img class="img3" src="https://obs.huahuaeco.com/official/home3.png" alt="">
    </section>

    <!-- 平台强力保障，售后问题不用愁 -->
    <section id="img-4" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')">
      <div class="img4-content">
        <h2 class="img4-title">平台强力保障，售后问题不用愁</h2>
        <div class="img4-desc">
          <p>服务方提供的售后服务，不得低于国家标准，</p>
          <p>未履行时将受到平台严厉处罚，</p>
          <p>并补偿业主损失，彻底解决您的后顾之忧</p>
        </div>
      </div>
      <img class="img4" src="https://obs.huahuaeco.com/official/home4.png" alt="">
    </section>

        <!-- 平台全程守护，交易更安心 -->
    <section id="img-41" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg.png')">
      <div class="img41-content">
        <h2 class="img41-title">平台全程守护，交易更安心</h2>
        <div class="img41-desc">
          <p>从签约到竣工，平台作为中立的守护者，</p>
          <p>全程见证并监督每一环节。</p>
          <p>我们确保一切按约定执行，始终站在您这边，</p>
          <p>为顺利完工保驾护航。</p>
        </div>
      </div>
      <img class="img41" src="https://obs.huahuaeco.com/official/home41.png" alt="">
    </section>

    <!-- 平台托底保障，服务至满意为止 -->
    <section id="img-5" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')">
      <div class="img5-content">
        <h2 class="img5-title">平台托底保障，服务至满意为止</h2>
        <div class="img5-desc">
          <p>一旦您与服务方合作破裂且无法协商，</p>
          <p>可申请平台托底服务，</p>
          <p>平台自营团队将立即接手，继续施工至您满意为止</p>
        </div>
      </div>
      <img class="img5" src="https://obs.huahuaeco.com/official/home5.png" alt="">
    </section>

    <!-- 在线交易流程 -->
    <!-- <section id="img-6" class="full-image img6-section" :style="img6Active === 'left' ? { backgroundImage: 'url(https://obs.huahuaeco.com/official/home/img6Left.png)' } : { backgroundImage: 'url(https://obs.huahuaeco.com/official/home/img6Right.png)' }"> -->
    <section id="img-6" class="full-image img6-section">
      <div class="img6-title1">在线交易流程</div>
      <div class="img6-title2">两种下单模式随心选，均可享平台保障</div>
      <div class="img6-toggle" aria-hidden="false">
        <button :class="['img6-btn', 'left', { active: img6Active === 'left' }]" @click.stop.prevent="setImg6('left')" aria-label="switch compare order mode">比价下单模式</button>
        <button :class="['img6-btn', 'right', { active: img6Active === 'right' }]" @click.stop.prevent="setImg6('right')" aria-label="switch invite order mode">邀约下单模式</button>
      </div>

      <div class="img-6-wrap">
        <img v-if="img6Active === 'left'" src="https://obs.huahuaeco.com/official/img6LeftImgs.png" alt="">
        <img v-else src="https://obs.huahuaeco.com/official/img6RightImgs.png" alt="">
      </div>
    </section>

    <!-- 平台合作伙伴 -->
    <!-- <section id="img-7" style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')"> -->
    <section id="img-7" style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')">
      <img src="https://obs.huahuaeco.com/official/brands.png" alt="">
      <div class="img7-title">平台合作伙伴</div>
    </section>

    <!-- 立即体验 -->
    <section id="img-8">
      <img src="https://obs.huahuaeco.com/official/qrcode.png">
      <div class="img8-title">
        <div class="img8-title1">立即体验</div>
        <div class="img8-title2">我们致力于服务至业主满意为止，不负每个客户的信任</div>
      </div>
    </section>

    <!-- 媒体报道 -->
    <section id="img-9">
      <div class="img9-inner">
        <h2 class="img9-title">媒体报道</h2>

        <div class="img9-grid">
          <a class="img9-card" href="https://sz.ifeng.com/c/8tSo7hhnMqv" target="_blank" rel="noopener noreferrer">
            <div class="img9-logo-wrap">
              <img class="img9-logo" src="https://obs.huahuaeco.com/official/media1.png" alt="凤凰网">
            </div>
            <p class="img9-desc">从六平方柜台到“化化”革命一记一个老工程人的“自寻烦恼”</p>
          </a>

          <a class="img9-card" href="https://www.jia360.com/new/257003.html" target="_blank" rel="noopener noreferrer">
            <div class="img9-logo-wrap">
              <img class="img9-logo" src="https://obs.huahuaeco.com/official/media2.png" alt="腾讯家居">
            </div>
            <p class="img9-desc">化化装修平台和传统装修平台有什么区别？一张表看懂</p>
          </a>

          <a class="img9-card" href="https://k.sina.com.cn/article_7763523677_1cebdf85d00101inqi.html?kdurlshow=1" target="_blank" rel="noopener noreferrer">
            <div class="img9-logo-wrap">
              <img class="img9-logo" src="https://obs.huahuaeco.com/official/media3.png" alt="新浪看点">
            </div>
            <p class="img9-desc">家装行业现“先装后付”新模式：第三方平台尝试破解信任困局</p>
          </a>
        </div>
      </div>
    </section>

    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue'
import SeoStaticImages from '../components/SeoStaticImages.vue'
import { useHead } from '@unhead/vue'
import { getPageHead } from '../utils/page-head'
export default {
  components: {
    AppFooter,
    SeoStaticImages
  },
  name: 'HomePage',
  setup() {
    useHead(getPageHead('home'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/home/home.png',
        'https://obs.huahuaeco.com/official/homeBg.png',
        'https://obs.huahuaeco.com/official/homeBg1.png',
        'https://obs.huahuaeco.com/official/img6LeftImgs.png',
        'https://obs.huahuaeco.com/official/img6RightImgs.png'
      ],
      imgList: [
        { url: 'https://obs.huahuaeco.com/official/home/img1e.png', alt: '开工0预付，装修更主动', msg: '100%装修款由平台托管，按阶段验收、满意再付款。', msg2: '用资金保障您的绝对话语权，让装修全程安心无忧。' },
        { url: 'https://obs.huahuaeco.com/official/home/img2e.png', alt: '口碑全公开，好坏不隐藏', msg: '每一位服务方的历史项目评价、优缺点均完整展示。', msg2: '为您提供最真实的“避坑指南”与决策参考，选择从未如此清晰。' },
        { url: 'https://obs.huahuaeco.com/official/home/img3e.png', alt: '告别装修扯皮，把“省心”装回家', msg: '交易在线、过程透明、信息可查。', msg2: '平台作为您最可靠的后盾，让纠纷处理变得轻松简单，装修全程省心又省力。' },
        { url: 'https://obs.huahuaeco.com/official/home/img4e.png', alt: '平台强力保障，售后问题不用愁', msg: '服务方提供的售后服务，不得低于国家标准。', msg2: '未履行时将受到平台严厉处罚，并补偿业主损失，彻底解决您的后顾之忧。' },
        { url: 'https://obs.huahuaeco.com/official/home/img5e.png', alt: '平台托底保障，服务至满意为止', msg: '一旦您与服务方合作破裂且无法协商，可申请平台托底服务。', msg2: '平台自营团队将立即接手，继续施工至您满意为止。' }
      ],
      img6Active: 'left',
      showFooter: true,
      keepFooterAfterImg5Jump: false,
      footerHiddenAfterImg5Scroll: false,
      footerJumpTouchStartY: 0
    }
  },
  methods: {
    setImg6(side) {
      this.img6Active = side
    },
    handleFooterAnchorClick(event) {
      const link = event.target.closest && event.target.closest('.feature-pill a[href^="#"]')
      if (!link) return

      const href = link.getAttribute('href')
      this.footerHiddenAfterImg5Scroll = false
      this.keepFooterAfterImg5Jump = href === '#img-5'
      if (this.keepFooterAfterImg5Jump) {
        this.showFooter = true
      }
    },
    handleFooterUserIntent(event) {
      if (!this.keepFooterAfterImg5Jump) return

      let shouldHide = false
      if (event.type === 'wheel') {
        shouldHide = event.deltaY > 0
      } else if (event.type === 'keydown') {
        shouldHide = ['ArrowDown', 'PageDown', ' ', 'End'].includes(event.key)
      } else if (event.type === 'touchstart') {
        this.footerJumpTouchStartY = event.touches && event.touches[0] ? event.touches[0].clientY : 0
      } else if (event.type === 'touchmove') {
        const touchY = event.touches && event.touches[0] ? event.touches[0].clientY : this.footerJumpTouchStartY
        shouldHide = this.footerJumpTouchStartY - touchY > 6
      }

      if (shouldHide) {
        this.keepFooterAfterImg5Jump = false
        this.footerHiddenAfterImg5Scroll = true
        this.showFooter = false
      }
    },
    handleScroll() {
      const img6 = document.getElementById('img-6')
      if (!img6) {
        this.showFooter = true
        return
      }
      const title = img6.querySelector('.img6-title1') || img6
      const titleTop = title.getBoundingClientRect().top
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
      const hideBeforeTitle = Math.min(180, Math.max(80, viewportHeight * 0.16))
      const shouldShow = titleTop > viewportHeight + hideBeforeTitle

      if (this.keepFooterAfterImg5Jump) {
        this.showFooter = true
        return
      }

      if (this.footerHiddenAfterImg5Scroll) {
        const img5 = document.getElementById('img-5')
        if (!img5 || img5.getBoundingClientRect().top <= 80) {
          this.showFooter = false
          return
        }
        this.footerHiddenAfterImg5Scroll = false
      }

      // 在线交易流程标题进入视口前隐藏，避免浮动栏覆盖标题和切换按钮。
      this.showFooter = shouldShow
    }
  }
  ,
  mounted() {
    this.handleScroll()
    this._boundHandleScroll = this.handleScroll.bind(this)
    this._boundHandleFooterAnchorClick = this.handleFooterAnchorClick.bind(this)
    this._boundHandleFooterUserIntent = this.handleFooterUserIntent.bind(this)
    document.addEventListener('click', this._boundHandleFooterAnchorClick, true)
    window.addEventListener('wheel', this._boundHandleFooterUserIntent, { passive: true })
    window.addEventListener('touchstart', this._boundHandleFooterUserIntent, { passive: true })
    window.addEventListener('touchmove', this._boundHandleFooterUserIntent, { passive: true })
    window.addEventListener('keydown', this._boundHandleFooterUserIntent)
    window.addEventListener('scroll', this._boundHandleScroll, { passive: true })
    window.addEventListener('resize', this._boundHandleScroll)
  },
  beforeUnmount() {
    if (this._boundHandleScroll) {
      window.removeEventListener('scroll', this._boundHandleScroll)
      window.removeEventListener('resize', this._boundHandleScroll)
    }
    if (this._boundHandleFooterAnchorClick) {
      document.removeEventListener('click', this._boundHandleFooterAnchorClick, true)
      window.removeEventListener('wheel', this._boundHandleFooterUserIntent)
      window.removeEventListener('touchstart', this._boundHandleFooterUserIntent)
      window.removeEventListener('touchmove', this._boundHandleFooterUserIntent)
      window.removeEventListener('keydown', this._boundHandleFooterUserIntent)
    }

  }
}
</script>

<style scoped lang="scss">
.home-page {
  overflow-x: hidden;
}

.full-image {
  height: 80vh !important;
}
.hero {
  background-image: url('https://obs.huahuaeco.com/official/home/home.png');
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  position: relative;
  padding: 2.1333rem 16px calc(180px + max(16px, env(safe-area-inset-bottom))) 1.3333rem;

  &-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-title {
    margin: 0;
    font-size: .5867rem; 
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: 6px;
    color: #262626;
    margin-bottom: 16px;
  }

  &-subtitle {
    margin: 22px 0 8px;
    font-size: .4rem;
    line-height: 1.6;
    color: #595959;
  }

  &-cta {
    display: inline-block;
    margin-top: .2rem;
    img {
      display: block;
      width: 4rem;
      height: .8rem;
      object-fit: cover;
    }
  }
}

.content-section {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  &.reverse {
    .section-inner {
      flex-direction: row-reverse;
    }
  }

  &::before {
    content: "";
    display: block;
    height: 0;
  }
}

.section-inner {
  display: flex;
  padding: 0 16px;
}

#img-6 {
  padding-top: 60px;
}

#img-7 {
  position: relative;
  min-height: 9.5rem;
  img {
    width: 80%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 2rem;
  }
  .img7-title {
    position: absolute;
    top: .8333rem;
    text-align: center;
    width: 100%;
  }
}

#img-8 {
  position: relative;
  height: 850px;
  img {
    width: 9rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 260px;
  }
  .img1-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 2;
  }
}

#img-9 {
  padding: 84px 24px 110px;
  background:
    radial-gradient(circle at top, rgba(228, 237, 247, 0.92) 0%, rgba(245, 248, 252, 0.94) 34%, #ffffff 82%),
    linear-gradient(180deg, #f5f8fc 0%, #ffffff 100%);
}

.img9-inner {
  width: min(1200px, 100%);
  margin: 0 auto;
}

.img9-title {
  margin: 0;
  color: #262626;
  text-align: center;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img9-grid {
  margin-top: 96px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.img9-card {
  display: block;
  min-height: 200px;
  padding: 42px 32px 30px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 16px 48px rgba(56, 89, 126, 0.08);
  text-decoration: none;
}

.img9-logo-wrap {
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img9-logo {
  max-width: min(100%, 220px);
  max-height: 52px;
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
}

.img9-desc {
  margin: 34px auto 0;
  max-width: 280px;
  color: #262626;
  text-align: center;
  font-size: 18px;
  line-height: 1.6;
}
.section-text {
  flex: 1;
  max-width: 720px;
}

.section-title {
  font-size: 46px;
  margin: 0 0 42px;
  color: #0b1220;
  text-align: left;
}

.section-desc {
  color: #475569;
  margin: 0 0 12px;
  line-height: 1.65;
  
  &.muted {
    color: #6b7280;
  }
}

.section-elem {
  img {
    max-width: 420px;
    width: 100%;
    height: auto;
    margin-top: 60px;
  }
}

.img6-section {
  position: relative;
  min-height: 86vh;
  background-color: #f4f7fb;
  background-size: cover;
  background-position: center center;
  display: block;
  transition: background-position 0.4s ease;
  padding-top: 50px;
}

#img-6 {
  min-height: 110vh;
  padding: 100px 24px 96px;
}
.img-6-wrap {
  display: flex;
  justify-content: center;
  position: relative;
  width: min(1180px, 90vw);
  margin: clamp(56px, 7vh, 84px) auto 0;
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.img6-title1 {
  color: #262626;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 20px;
}

.img7-title {
  color: #262626;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 20px;
}

.img6-title2 {
  color: #595959;
  text-align: center;
  font-size: 24px;
}

.img8-title {
  position: absolute;
  top: 0.7rem;
  width: 100%;
  .img8-title1 {
    color: #262626;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .img8-title2 {
    color: #595959;
    text-align: center;
    font-size: 24px;
  }
}


.img6-toggle {
  position: relative;
  width: fit-content;
  margin: 24px auto 0;
  z-index: 95;
  display: flex;
  gap: 0;
  padding: 4px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(22, 95, 230, 0.10);
  pointer-events: auto;
}

.img6-btn {
  width: clamp(150px, 18vw, 188px);
  height: 60px;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: #262626;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.img6-btn.active {
  color: #fff;
  background: linear-gradient(90deg, #5bf7fe, #198CFE);
  box-shadow: 0 8px 18px rgba(25, 140, 254, 0.25);
}


@media (max-width: 1300px) {
  #img-1, #img-2, #img-3, #img-4, #img-41, #img-5 {
    padding-left: 1rem !important;
    min-height: 520px !important;
    position: relative;
    overflow: hidden;
  }
  .img1-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 !important;
    top: 4rem;
  }
  .img1 {
    top: 3rem !important;
    width: 4rem !important;
    height: 4rem !important;
  }

  .img2-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 1rem !important;
    top: 2rem;
  }

  .img2 {
    top: 4.5rem !important;
    width: 4rem !important;
    height: 4rem !important;
    left: initial !important;
    right: 1rem !important;
    position: absolute !important;
  }

  .img3-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 1rem !important;
    top: 2rem;
  }

  .img3 {
    bottom: 0.5rem !important;
    top: 4.6rem !important;
    width: 4rem !important;
    height: 4rem !important;
    left: initial !important;
    right: -1rem !important;
    transform: translateX(-50%) !important;
  }

  .img4-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 1rem !important;
    top: 5rem !important;
  }

  .img4 {
    bottom: 0.5rem !important;
    top: 7rem !important;
    width: 4rem !important;
    height: 4rem !important;
    right: -1rem !important;
    left: initial !important;
    transform: translateX(-50%) !important;
  }

  .img41-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 0 0 1rem !important;
    top: 4rem !important;
  }

  .img41 {
    bottom: 1rem !important;
    width: 6rem !important;
    height: 6rem !important;
    right: -2rem !important;
    top: 4rem !important;
    transform: translateX(-50%) !important;
    
  }

  .img5-content {
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    padding: 0 !important;
    top: 5rem !important;
  }

  .img5 {
    bottom: 1rem !important;
    width: 5rem !important;
    height: 5rem !important;
    left: initial !important;
    right: -2rem;
    top: 4rem !important;
    transform: translateX(-50%) !important;
  }

  #img-1, #img-2, #img-3, #img-4, #img-41, #img-5 {
    display: grid !important;
    grid-template-columns: minmax(0, 560px) minmax(180px, 280px);
    column-gap: clamp(20px, 3vw, 36px);
    align-items: center;
    justify-content: center;
    height: auto !important;
    padding: clamp(36px, 5vw, 60px) clamp(36px, 7vw, 84px) !important;
  }

  .img1-content,
  .img2-content,
  .img3-content,
  .img4-content,
  .img41-content,
  .img5-content {
    position: relative !important;
    grid-column: 1;
    grid-row: 1;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    bottom: auto !important;
    transform: none !important;
    width: auto !important;
    max-width: 560px;
    padding: 0 !important;
    justify-self: start;
    text-align: left;
    z-index: 2;
  }

  .img1,
  .img2,
  .img3,
  .img4,
  .img41,
  .img5 {
    position: relative !important;
    grid-column: 2;
    grid-row: 1;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    bottom: auto !important;
    transform: none !important;
    width: clamp(180px, 24vw, 300px) !important;
    height: auto !important;
    object-fit: contain;
    justify-self: center;
    align-self: center;
    z-index: 1;
  }

  .img1,
  .img41 {
    width: clamp(200px, 26vw, 320px) !important;
  }

  .img1-title,
  .img2-title,
  .img3-title,
  .img4-title,
  .img41-title,
  .img5-title {
    margin: 0 0 clamp(16px, 2vw, 26px) !important;
    font-size: clamp(30px, 2.8vw, 40px) !important;
    line-height: 1.25;
  }

  .img1-desc,
  .img2-desc p,
  .img3-desc,
  .img4-desc,
  .img4-desc p,
  .img41-desc,
  .img41-desc p,
  .img5-desc,
  .img5-desc p {
    margin-bottom: 10px !important;
    font-size: clamp(17px, 1.7vw, 21px) !important;
    line-height: 1.65;
  }

  .img2-desc,
  .img4-desc,
  .img41-desc,
  .img5-desc {
    margin: 0 !important;
  }

  #img-6 {
    height: auto !important;
    min-height: auto !important;
    padding-top: 50px !important;
    padding-bottom: 56px !important;
    overflow: visible;
  }
  .img-6-wrap {
    margin-top: clamp(42px, 6vw, 68px) !important;
    img {
      width: 100%;
    }
  }

  .img6-toggle {
    margin-top: 18px;
  }

  .img6-btn {
    width: clamp(138px, 20vw, 176px);
    height: 52px;
    font-size: 18px;
  }

  @media (max-width: 900px) {
    #img-1, #img-2, #img-3, #img-4, #img-41, #img-5 {
      grid-template-columns: minmax(0, 460px) minmax(140px, 180px);
      column-gap: 14px;
      justify-content: center;
      padding: 32px 40px !important;
    }

    .img1, .img2, .img3, .img4, .img41, .img5 {
      width: clamp(140px, 22vw, 180px) !important;
    }

    .img1-title,
    .img2-title,
    .img3-title,
    .img4-title,
    .img41-title,
    .img5-title {
      font-size: 28px !important;
      margin-bottom: 16px !important;
    }

    .img1-desc,
    .img2-desc p,
    .img3-desc,
    .img4-desc,
    .img4-desc p,
    .img41-desc,
    .img41-desc p,
    .img5-desc,
    .img5-desc p {
      font-size: 18px !important;
      line-height: 1.55;
    }
  }

  #img-7 {
    min-height: 560px;
    overflow: hidden;
  }

  #img-8 {
    height: auto;
    min-height: 720px;
    overflow: hidden;
  }

  #img-9 {
    padding: 72px 32px 88px;
  }

  .img9-title {
    font-size: 40px;
  }

  .img9-grid {
    margin-top: 64px;
    gap: 20px;
  }

  .img9-card {
    padding: 34px 24px 26px;
  }

  .img9-desc {
    margin-top: 24px;
    font-size: 16px;
  }
}

#img-1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: center;
  height: 900px;
  .img1 {
    width: 5rem;
    height: 5rem;
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    z-index: 0;
  }
  .img1-content {
    position: absolute;
    left: 3rem;
    padding-right: 1.6667rem;
    z-index: 2;
  }
  .img1-title {
    margin: 0 0 64px;
    font-size: .64rem;
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img1-desc {
    margin: 0 0 26px;
    font-size: .4rem;
    line-height: 1.65;
    font-size: 24px;
    color: #8c8c8c;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

#img-2 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 2.6667rem;
  .img2-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2.6667rem;
    padding-left: 1.6667rem;
    z-index: 2;
  }
  .img2 {
    width: 6.6667rem;
    height: 6.6667rem;
    position: absolute;
    bottom: 1rem;
    left: 1.3333rem;
    z-index: 0;
  }
  .img2-title {
    margin: 0 0 64px;
    font-size: clamp(34px, 3.4vw, 64px);
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img2-desc {
    margin: 0 0 26px;
    p {
      font-size: clamp(20px, 1.5vw, 40px);
      line-height: 1.6;
      font-size: 24px;
      color: #8c8c8c;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}


#img-3 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 310px);
  background-position: center;

  .img3-content {
    position: absolute;
    top: 50%;
    left: 2.6667rem;
    transform: translateY(-50%);
    padding-right: 1.6667rem;
    z-index: 2;
  }
  .img3 {
    width: 6.6667rem;
    height: 6.6667rem;
    position: absolute;
    bottom: 1.3333rem;
    right: 1.3333rem;
    z-index: 0;
  }
  
  .img3-title {
    margin: 0 0 64px;
    font-size: clamp(34px, 3.4vw, 64px);
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img3-desc {
    margin: 0 0 26px;
    font-size: clamp(20px, 1.5vw, 40px);
    line-height: 1.65;
    font-size: 24px;
    color: #8c8c8c;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

#img-4 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 310px);
  background-position: center;

  .img4-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2.6667rem;
    padding-left: 1.6667rem;
    z-index: 2;
  }
  .img4 {
    width: 6.6667rem;
    height: 6.6667rem;
    position: absolute;
    bottom: 1.3333rem;
    left: 1.3333rem;
    z-index: 0;
  }
  .img4-title {
    margin: 0 0 64px;
    font-size: clamp(34px, 3.4vw, 64px);
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img4-desc {
    margin: 0 0 26px;
    font-size: clamp(20px, 1.5vw, 40px);
    line-height: 1.65;
    font-size: 24px;
    color: #8c8c8c;
    text-align: left;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

#img-41 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 310px);
  background-position: center;
  .img41-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 2.6667rem;
    padding-right: 1.6667rem;
    z-index: 2;
  }
  .img41 {
    width: 6.6667rem;
    height: 6.6667rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.3333rem;
    z-index: 0;
  }
  .img41-title {
    margin: 0 0 64px;
    font-size: clamp(34px, 3.4vw, 64px);
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img41-desc {
    margin: 0 0 26px;
    font-size: clamp(20px, 1.5vw, 40px);
    line-height: 1.65;
    font-size: 24px;
    color: #8c8c8c;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

#img-5 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 310px);
  background-position: center;
  .img5-content {
    position: absolute;
    top: 50%;
    max-width: 900px;
    transform: translateY(-50%);
    right: 2.6667rem;
    padding-left: 1.6667rem;
    z-index: 2;
  }
  .img5 {
    width: 6.6667rem;
    height: 6.6667rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1.3333rem;
    z-index: 0;
  }
  .img5-title {
    margin: 0 0 64px;
    font-size: clamp(34px, 3.4vw, 64px);
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
  }
  .img5-desc {
    margin: 0 0 26px;
    font-size: clamp(20px, 1.5vw, 40px);
    line-height: 1.65;
    font-size: 24px;
    text-align: left;
    color: #8c8c8c;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 1600px) {
  #img-1,
  #img-2,
  #img-3,
  #img-4,
  #img-41,
  #img-5 {
    display: grid !important;
    align-items: center;
    column-gap: clamp(36px, 5vw, 72px);
    height: auto !important;
    min-height: clamp(560px, 52vw, 720px) !important;
    padding: clamp(64px, 6vw, 96px) clamp(56px, 8vw, 120px) !important;
    overflow: hidden;
  }

  #img-1,
  #img-3,
  #img-41 {
    grid-template-columns: minmax(0, 720px) minmax(300px, 500px);
  }

  #img-2,
  #img-4,
  #img-5 {
    grid-template-columns: minmax(300px, 500px) minmax(0, 760px);
  }

  #img-1 .img1-content,
  #img-3 .img3-content,
  #img-41 .img41-content {
    grid-column: 1;
  }

  #img-2 .img2-content,
  #img-4 .img4-content,
  #img-5 .img5-content {
    grid-column: 2;
  }

  #img-1 .img1,
  #img-3 .img3,
  #img-41 .img41 {
    grid-column: 2;
  }

  #img-2 .img2,
  #img-4 .img4,
  #img-5 .img5 {
    grid-column: 1;
  }

  #img-1 .img1-content,
  #img-2 .img2-content,
  #img-3 .img3-content,
  #img-4 .img4-content,
  #img-41 .img41-content,
  #img-5 .img5-content {
    position: relative !important;
    grid-row: 1;
    top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
    transform: none !important;
    width: auto !important;
    max-width: 760px !important;
    padding: 0 !important;
    justify-self: start;
    z-index: 2;
  }

  #img-2 .img2-content,
  #img-4 .img4-content,
  #img-5 .img5-content {
    justify-self: start;
  }

  #img-1 .img1,
  #img-2 .img2,
  #img-3 .img3,
  #img-4 .img4,
  #img-41 .img41,
  #img-5 .img5 {
    position: relative !important;
    grid-row: 1;
    top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
    transform: none !important;
    width: min(100%, 430px) !important;
    height: auto !important;
    object-fit: contain;
    justify-self: center;
    align-self: center;
    z-index: 1;
  }

  #img-1 .img1,
  #img-41 .img41 {
    width: min(100%, 460px) !important;
  }

  #img-1 .img1-title,
  #img-2 .img2-title,
  #img-3 .img3-title,
  #img-4 .img4-title,
  #img-41 .img41-title,
  #img-5 .img5-title {
    margin: 0 0 clamp(24px, 3vw, 42px) !important;
    font-size: clamp(36px, 4vw, 52px) !important;
    line-height: 1.18;
  }

  #img-1 .img1-desc,
  #img-2 .img2-desc p,
  #img-3 .img3-desc,
  #img-4 .img4-desc,
  #img-4 .img4-desc p,
  #img-41 .img41-desc,
  #img-41 .img41-desc p,
  #img-5 .img5-desc,
  #img-5 .img5-desc p {
    margin-bottom: 12px !important;
    font-size: clamp(19px, 2vw, 24px) !important;
    line-height: 1.65 !important;
  }

  #img-2 .img2-desc,
  #img-4 .img4-desc,
  #img-41 .img41-desc,
  #img-5 .img5-desc {
    margin: 0 !important;
  }
}

@media (max-width: 1100px) {
  #img-1,
  #img-2,
  #img-3,
  #img-4,
  #img-41,
  #img-5 {
    grid-template-columns: 1fr !important;
    row-gap: 28px;
    min-height: auto !important;
    padding: 54px 32px 0 !important;
  }

  #img-1 .img1-content,
  #img-2 .img2-content,
  #img-3 .img3-content,
  #img-4 .img4-content,
  #img-41 .img41-content,
  #img-5 .img5-content {
    grid-column: 1;
    grid-row: 1;
    max-width: 720px !important;
    justify-self: center;
    text-align: center;
  }

  #img-1 .img1,
  #img-2 .img2,
  #img-3 .img3,
  #img-4 .img4,
  #img-41 .img41,
  #img-5 .img5 {
    grid-column: 1;
    grid-row: 2;
    width: min(420px, 76vw) !important;
  }
}

#img-6.img6-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto !important;
  min-height: 100vh;
  min-height: 100svh;
  box-sizing: border-box;
  overflow: visible;
  padding: clamp(56px, 8vh, 100px) 24px clamp(64px, 8vh, 104px) !important;
}

#img-6 .img-6-wrap {
  flex: 0 1 auto;
  width: min(1180px, calc(100vw - 72px));
  margin: clamp(40px, 6vh, 76px) auto 0 !important;
}

#img-6 .img-6-wrap img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

@media (max-height: 760px) {
  #img-6.img6-section {
    min-height: auto !important;
    padding-top: 44px !important;
    padding-bottom: 48px !important;
  }

  #img-6 .img6-title1 {
    font-size: 34px;
    margin-bottom: 12px;
  }

  #img-6 .img6-title2 {
    font-size: 22px;
  }

  #img-6 .img6-toggle {
    margin-top: 16px;
  }

  #img-6 .img6-btn {
    height: 52px;
  }

  #img-6 .img-6-wrap {
    margin-top: 30px !important;
  }

  #img-6 .img-6-wrap img {
    max-height: max(300px, calc(100vh - 285px));
    max-height: max(300px, calc(100svh - 285px));
  }
}

@media (max-height: 640px) {
  #img-6.img6-section {
    padding-top: 32px !important;
    padding-bottom: 40px !important;
  }

  #img-6 .img6-title1 {
    font-size: 30px;
    margin-bottom: 8px;
  }

  #img-6 .img6-title2 {
    font-size: 21px;
  }

  #img-6 .img6-toggle {
    margin-top: 14px;
  }

  #img-6 .img6-btn {
    height: 48px;
  }

  #img-6 .img-6-wrap {
    margin-top: 24px !important;
  }

  #img-6 .img-6-wrap img {
    max-height: max(270px, calc(100vh - 245px));
    max-height: max(270px, calc(100svh - 245px));
  }
}

@media (max-width: 1100px) {
  .img9-grid {
    grid-template-columns: 1fr;
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<!-- 全局平滑滚动（非 scoped） -->
<style lang="scss">
html {
  scroll-behavior: smooth;
}

/* 覆盖 hero 全区的可点击锚点 */
.hero-link {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

/* .hero-link{position:absolute;inset:0;display:block;width:420px;height:200px;background:transparent;border:0;margin:0;padding:0;cursor:pointer;top: 58%;left: 22%;} */
</style>
